<template>
  <svg
    width="47"
    height="47"
    viewBox="0 0 47 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1911_34952)">
      <rect x="2" y="1" width="43" height="43" rx="2.6875" fill="#F7F3FF" />
      <path
        d="M27.6992 26.6992L31.8984 22.5L27.6992 18.3008M19.3008 18.3008L15.1016 22.5L19.3008 26.6992M25.1797 14.9414L21.8203 30.0586"
        stroke="#6434D0"
        stroke-width="1.47812"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1911_34952"
        x="0.65625"
        y="0.328125"
        width="45.6875"
        height="45.6875"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.671875" />
        <feGaussianBlur stdDeviation="0.671875" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1911_34952"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1911_34952"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
